import React, { Component, PropTypes } from 'react'

import { getProperty, filterObject, cameraExperienceOptions } from '../utils'
import { Loading } from '../misc'
import {
    Boolean,
    Label,
    MultipleCheckbox,
    TextInput,
} from '../ui'

export default class CameraAssistant extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    _updateValueAndSendPatchRequest = (data) => {
        this.props.updateValue(data)
        this._sendPatchRequest(data)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [
                'camera_experience',
                'wireless_focus_experience',
                'wireless_focus_models',
                'gimbal_experience',
                'gimbal_models',
                'film_camera_experience',
                'film_camera_models',
                'steadicam_experience',
                'will_work_as_second_ac',
            ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        let wirelessFocusModels = null
        let gimbalModels = null
        let filmCameraModels = null

        if (getProperty(this.props.data, 'wireless_focus_experience', false) === true) {
            wirelessFocusModels = (
                <TextInput
                    error={ errors.wireless_focus_models }
                    handleBlur={ this._sendPatchRequest }
                    name="wireless_focus_models"
                    placeholder="List models"
                    type="textarea"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'wireless_focus_models') }
                />
            )
        }

        if (getProperty(this.props.data, 'gimbal_experience', false) === true) {
            gimbalModels = (
                <TextInput
                    error={ errors.gimbal_models }
                    handleBlur={ this._sendPatchRequest }
                    name="gimbal_models"
                    placeholder="List models"
                    type="textarea"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'gimbal_models') }
                />
            )
        }

        if (getProperty(this.props.data, 'film_camera_experience', false) === true) {
            filmCameraModels = (
                <TextInput
                    error={ errors.film_camera_models }
                    handleBlur={ this._sendPatchRequest }
                    name="film_camera_models"
                    placeholder="List models"
                    type="textarea"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'film_camera_models') }
                />
            )
        }

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Camera Experience
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <Label>
                            Please check off all cameras you are proficient as a FIRST AC / CAMERA ASSISTANT:
                        </Label>
                        <MultipleCheckbox
                            columns={ 2 }
                            error={ errors.camera_experience }
                            name="camera_experience"
                            options={ cameraExperienceOptions() }
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'camera_experience', []) || [] }
                        />

                        <hr />

                        <p>Do you have experience with:</p>

                        <Boolean
                            error={ errors.wireless_focus_experience }
                            label="Wireless focus?"
                            name="wireless_focus_experience"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'wireless_focus_experience') }
                        />
                        { wirelessFocusModels }
                        <Boolean
                            error={ errors.gimbal_experience }
                            label="Gimbal setup and balancing?"
                            name="gimbal_experience"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'gimbal_experience') }
                        />
                        { gimbalModels }
                        <Boolean
                            error={ errors.film_camera_experience }
                            label="Film cameras?"
                            name="film_camera_experience"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'film_camera_experience') }
                        />
                        { filmCameraModels }
                        <Boolean
                            error={ errors.steadicam_experience }
                            label="Steadicam?"
                            name="steadicam_experience"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'steadicam_experience') }
                        />

                        <Boolean
                            error={ errors.will_work_as_second_ac }
                            label="Will you work as a second AC?"
                            name="will_work_as_second_ac"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'will_work_as_second_ac') }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/camera_assistant.js